import React, { ReactNode } from 'react'
import MainContainer from '../MainContainer'
import OuterContainer from '../OuterContainer'
import classNames from 'classnames'
import styles from './moduleWrapper.module.scss'

interface Props {
  children: ReactNode
  outerContainerClass?: string
  innerContainerClass?: string
}

const ModuleWrapper = ({ children, outerContainerClass = '', innerContainerClass = '' }: Props) => {
  return (
    <OuterContainer className={classNames(styles.outerContainer, outerContainerClass)}>
      <MainContainer hasBorder className={classNames(styles.innerContainer, innerContainerClass)}>
        {children}
      </MainContainer>
    </OuterContainer>
  )
}

export default ModuleWrapper
